(function () {
  var endpoint = 'https://mail-cebdwlkvzs.cn-hangzhou.fcapp.run/inquiry';
  var formSelector =
    'form[data-oulai-inquiry-form], #ContactForm, #B2BQuoteForm, #OulaiLiveChatForm, form[id^="B2BCartQuoteForm-"]';
  var defaultContact = {
    key: 'jasmine',
    name: 'Jasmine',
    email: 'jasmine@ntoulai.com',
    phone: '+86 18012295285',
  };

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function contactKey(contact) {
    var value = clean(contact && (contact.key || contact.name || contact.email)).toLowerCase();

    if (value.indexOf('zhang') >= 0 || value === 'zh') return 'zhang';
    if (value.indexOf('catherine') >= 0) return 'catherine';

    return 'jasmine';
  }

  function assignedContact(root) {
    if (typeof window.__oulaiRefreshAssignedContacts === 'function') {
      window.__oulaiRefreshAssignedContacts(root || document);
    }

    if (typeof window.__oulaiGetAssignedContact === 'function') {
      return window.__oulaiGetAssignedContact();
    }

    return defaultContact;
  }

  function readByName(form, names) {
    for (var index = 0; index < names.length; index += 1) {
      var field = form.elements.namedItem(names[index]);

      if (field && clean(field.value)) {
        return clean(field.value);
      }
    }

    return '';
  }

  function isInquiryForm(form) {
    return form && typeof form.matches === 'function' && form.matches(formSelector);
  }

  function readBySelector(form, selectors) {
    for (var index = 0; index < selectors.length; index += 1) {
      var field = form.querySelector(selectors[index]);

      if (field && clean(field.value)) {
        return clean(field.value);
      }
    }

    return '';
  }

  function formSource(form) {
    if (form.id === 'B2BQuoteForm') return 'B2B homepage quote form';
    if (form.id && form.id.indexOf('B2BCartQuoteForm-') === 0) return 'B2B cart quote request';

    return 'Website Contact Us';
  }

  function buildPayloadFromForm(form) {
    var contact = assignedContact(form);
    var message = readByName(form, ['message', 'contact[body]', 'contact[Comment]', 'contact[comment]']);
    var cartSummary = readByName(form, ['cartSummary', 'contact[cart_summary]']);
    var assignedSales = readByName(form, ['assignedSales', 'contact[assigned_sales]']);

    if (!message) {
      message = readBySelector(form, [
        '#ContactForm-body',
        'textarea[id*="QuoteMessage"]',
        'textarea[id*="QuoteRequirements"]',
        'textarea',
      ]);
    }

    if (cartSummary) {
      message += '\n\nCart summary:\n' + cartSummary;
    }

    return {
      salesKey: readByName(form, ['salesKey']) || contactKey(contact),
      assignedSales: contact && contact.name ? contact.name : assignedSales || defaultContact.name,
      copyToInquiry: false,
      name:
        readByName(form, ['name', 'contact[name]', 'contact[Name]']) ||
        readBySelector(form, ['#ContactForm-name', 'input[id*="QuoteName"]']),
      email: readByName(form, ['email', 'contact[email]']) || readBySelector(form, ['input[type="email"]']),
      phone:
        readByName(form, ['phone', 'contact[phone]', 'contact[Phone or WhatsApp]', 'contact[Phone]']) ||
        readBySelector(form, ['input[type="tel"]', 'input[id*="Phone"]']),
      company:
        readByName(form, ['company', 'contact[company]', 'contact[Company]']) ||
        readBySelector(form, ['input[id*="Company"]']),
      country:
        readByName(form, ['country', 'contact[country]', 'contact[Country Code]', 'country_code']) ||
        readBySelector(form, ['input[id*="Country"]']),
      quantity:
        readByName(form, ['quantity', 'contact[target_quantity]']) ||
        readBySelector(form, ['input[id*="TargetQuantity"]']),
      product: readByName(form, ['product', 'contact[product]', 'contact[Product]']),
      message: message,
      pageUrl: readByName(form, ['pageUrl']) || window.location.href,
      source: readByName(form, ['source', 'contact[subject]', 'contact[tags]']) || formSource(form),
      _gotcha: readByName(form, ['_gotcha', 'website_hidden']),
    };
  }

  function submitInquiry(payload, targetEndpoint) {
    var normalizedPayload = Object.assign({}, payload, { copyToInquiry: false });

    return fetch(targetEndpoint || endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(normalizedPayload),
    }).then(function (response) {
      return response.text().then(function (text) {
        var data = {};

        try {
          data = text ? JSON.parse(text) : {};
        } catch (error) {
          data = { error: text };
        }

        if (!response.ok || data.ok === false) {
          throw new Error(data.error || data.detail || 'Inquiry submission failed.');
        }

        return data;
      });
    });
  }

  function queueAssignedCopy(payload) {
    var body = JSON.stringify(Object.assign({}, payload, { copyToInquiry: false }));

    if (window.navigator && typeof window.navigator.sendBeacon === 'function') {
      try {
        if (window.navigator.sendBeacon(endpoint, new Blob([body], { type: 'application/json' }))) {
          return;
        }
      } catch (error) {
      }
    }

    try {
      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: body,
        keepalive: true,
      }).catch(function () {
      });
    } catch (error) {
    }
  }

  function handleSubmit(event) {
    var form = event.target;
    var payload;

    if (!isInquiryForm(form)) {
      return;
    }

    if (form.dataset.oulaiAssignedCopySent === 'true') {
      return;
    }

    prepareForm(form);

    if (!form.checkValidity()) {
      if (typeof form.reportValidity === 'function') {
        form.reportValidity();
      }

      return;
    }

    payload = buildPayloadFromForm(form);

    if (!payload.email || !payload.message) {
      return;
    }

    form.dataset.oulaiAssignedCopySent = 'true';
    queueAssignedCopy(payload);
  }

  function prepareForm(form) {
    form.dataset.oulaiInquiryBound = 'true';
  }

  function bindForms(root) {
    var scope = root || document;

    scope.querySelectorAll(formSelector).forEach(function (form) {
      prepareForm(form);
    });
  }

  window.__oulaiSubmitInquiry = submitInquiry;
  window.__oulaiBuildInquiryPayloadFromForm = buildPayloadFromForm;
  window.__oulaiGetInquiryContactKey = contactKey;
  window.__oulaiHandleInquirySubmit = handleSubmit;

  document.addEventListener('submit', handleSubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindForms(document);
    });
  } else {
    bindForms(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindForms(event.target);
  });
})();
